/* nav scroll state */
document.querySelectorAll('.bar-series-landing').forEach(root => {
if (root.dataset.barSeriesLandingInit === 'true') return;
root.dataset.barSeriesLandingInit = 'true';
const nav = root.querySelector('#bsl-nav');
addEventListener('scroll', () => {
  if (!nav) return;
  nav.classList.toggle('scrolled', scrollY > 40);
}, {passive:true});

/* hero parallax */
const heroBg = root.querySelector('#bsl-heroBg');
addEventListener('scroll', () => {
  if (!heroBg) return;
  const y = scrollY;
  if (y < innerHeight) heroBg.style.transform = `translateY(${y * 0.28}px)`;
}, {passive:true});

/* reveal on scroll — anything already in view (anchor landings, scroll
   restoration) appears instantly instead of waiting for a transition */
const revealObs = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); revealObs.unobserve(e.target); }
  });
}, {threshold: 0.12, rootMargin: '0px 0px -40px 0px'});
root.querySelectorAll('.reveal').forEach(el => {
  const r = el.getBoundingClientRect();
  if (r.top < innerHeight && r.bottom > 0) {
    el.style.transition = 'none';
    el.classList.add('in');
    requestAnimationFrame(() => requestAnimationFrame(() => { el.style.transition = ''; }));
  } else {
    revealObs.observe(el);
  }
});

/* animated counters */
const countObs = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (!e.isIntersecting) return;
    countObs.unobserve(e.target);
    const el = e.target, target = +el.dataset.target;
    if (target === 0) { el.textContent = '0'; return; }
    const dur = 1400, t0 = performance.now();
    (function tick(t) {
      const p = Math.min((t - t0) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString();
      if (p < 1) requestAnimationFrame(tick);
    })(t0);
  });
}, {threshold: 0.6});
root.querySelectorAll('.count').forEach(el => countObs.observe(el));

/* lightsaber ignition */
const saber = root.querySelector('#bsl-saber');
if (saber) {
  new IntersectionObserver((entries, obs) => {
    entries.forEach(e => {
      if (e.isIntersecting) { saber.classList.add('lit'); obs.disconnect(); }
    });
  }, {threshold: 0.5}).observe(saber.parentElement);
}

/* fusioncore color lab — drag-wipe comparison slider */
const fcStage = root.querySelector('#bsl-fcStage');
const fcCta = root.querySelector('#bsl-fcCta');
const colorName = root.querySelector('#bsl-colorName');
const colorCopy = {
  brorange: ['Brorange', 'Bronze + orange. The statement. The one from the launch film.'],
  silver: ['Silver', 'Clean. Classic. For people who whisper.']
};
const colorHref = {
  brorange: 'https://www.beyond-power.com/products/fusioncore-bar?variant=45884095103112',
  silver: 'https://www.beyond-power.com/products/fusioncore-bar'
};
let fcColor = 'brorange';
function setWipe(pct, animate) {
  if (!fcStage) return;
  pct = Math.max(0, Math.min(100, pct));
  fcStage.classList.toggle('animating', !!animate);
  fcStage.style.setProperty('--w', pct + '%');
  const c = pct >= 50 ? 'brorange' : 'silver';
  if (c !== fcColor) {
    fcColor = c;
    fcStage.classList.toggle('brorange-on', c === 'brorange');
    fcCta.href = colorHref[c];
    colorName.innerHTML = `${colorCopy[c][0]}<small>${colorCopy[c][1]}</small>`;
    root.querySelectorAll('.swatch').forEach(b =>
      b.classList.toggle('active', b.dataset.color === c));
  }
}
let dragging = false;
fcStage && fcStage.addEventListener('pointerdown', e => {
  dragging = true;
  const r = fcStage.getBoundingClientRect();
  setWipe((e.clientX - r.left) / r.width * 100, false);
  try { fcStage.setPointerCapture(e.pointerId); } catch (_) {}
});
fcStage && fcStage.addEventListener('pointermove', e => {
  if (!dragging) return;
  const r = fcStage.getBoundingClientRect();
  setWipe((e.clientX - r.left) / r.width * 100, false);
});
fcStage && ['pointerup', 'pointercancel'].forEach(ev => fcStage.addEventListener(ev, () => { dragging = false; }));
root.querySelectorAll('.swatch').forEach(btn => {
  btn.addEventListener('click', () => setWipe(btn.dataset.color === 'brorange' ? 100 : 0, true));
});

/* compare column hover highlight */
root.querySelectorAll('[data-col]').forEach(cell => {
  cell.addEventListener('mouseenter', () => {
    root.querySelectorAll(`[data-col="${cell.dataset.col}"]`).forEach(c => c.classList.add('compare-col-hover'));
  });
  cell.addEventListener('mouseleave', () => {
    root.querySelectorAll(`[data-col="${cell.dataset.col}"]`).forEach(c => c.classList.remove('compare-col-hover'));
  });
});

/* scroll progress bar */
const progress = root.querySelector('#bsl-progress');
addEventListener('scroll', () => {
  if (!progress) return;
  const max = document.documentElement.scrollHeight - innerHeight;
  progress.style.width = (max > 0 ? (scrollY / max) * 100 : 0) + '%';
}, {passive:true});

/* brorange spotlight — mouse tilt (pointer devices only) */
const tiltZone = root.querySelector('#bsl-tiltZone');
const tiltBar = root.querySelector('#bsl-tiltBar');
if (matchMedia('(hover:hover) and (prefers-reduced-motion:no-preference)').matches) {
  tiltZone && tiltBar && tiltZone.addEventListener('pointermove', e => {
    const r = tiltZone.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    tiltBar.style.transform = `rotateY(${x * 14}deg) rotateX(${-y * 10}deg) translateZ(20px) scale(1.02)`;
  });
  tiltZone && tiltBar && tiltZone.addEventListener('pointerleave', () => { tiltBar.style.transform = ''; });
}

/* launch film — play in view, sound toggle, scroll scale */
const filmVideo = root.querySelector('#bsl-filmVideo');
const videoShell = root.querySelector('#bsl-videoShell');
const soundBtn = root.querySelector('#bsl-soundBtn');
if (filmVideo && videoShell) {
  new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) filmVideo.play().catch(() => {});
      else filmVideo.pause();
    });
  }, {threshold: 0.35}).observe(videoShell);
}
soundBtn && filmVideo && soundBtn.addEventListener('click', () => {
  filmVideo.muted = !filmVideo.muted;
  soundBtn.textContent = filmVideo.muted ? 'Sound off' : 'Sound on';
  if (!filmVideo.muted) filmVideo.play().catch(() => {});
});
addEventListener('scroll', () => {
  if (!videoShell) return;
  const r = videoShell.getBoundingClientRect();
  if (r.bottom < 0 || r.top > innerHeight) return;
  const mid = r.top + r.height / 2;
  const dist = Math.abs(mid - innerHeight / 2) / (innerHeight / 2);
  const s = 1.02 - Math.min(dist, 1) * 0.07;
  videoShell.style.transform = `scale(${s})`;
}, {passive:true});

/* move pills — roving highlight */
const pills = [...root.querySelectorAll('#bsl-movePills .pill')];
let pillIdx = 0;
if (pills.length) {
  setInterval(() => {
    pills.forEach(p => p.classList.remove('lit'));
    pills[pillIdx % pills.length].classList.add('lit');
    pillIdx++;
  }, 1400);
}

/* cursor spotlight on cards */
root.querySelectorAll('.feature-card,.lineup-card,.benefit,.aluma-stat,.box-card,.voltra-card').forEach(card => {
  card.classList.add('glow-card');
  card.addEventListener('pointermove', e => {
    const r = card.getBoundingClientRect();
    card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
    card.style.setProperty('--my', (e.clientY - r.top) + 'px');
  });
});

/* mobile dock — appear after hero, highlight active section */
const dock = root.querySelector('#bsl-dock');
const dockLinks = dock ? [...dock.querySelectorAll('a')] : [];
const dockSections = dockLinks.map(a => root.querySelector(a.getAttribute('href')) || document.querySelector(a.getAttribute('href')));
addEventListener('scroll', () => {
  if (!dock) return;
  dock.classList.toggle('show', scrollY > innerHeight * 0.6);
  let active = -1;
  dockSections.forEach((sec, i) => {
    if (sec && sec.offsetTop <= scrollY + innerHeight * 0.4) active = i;
  });
  dockLinks.forEach((a, i) => a.classList.toggle('active', i === active));
}, {passive:true});

/* magnetic primary buttons */
if (matchMedia('(hover:hover)').matches) {
  root.querySelectorAll('.btn-primary,.btn-sith').forEach(btn => {
    btn.addEventListener('pointermove', e => {
      const r = btn.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      btn.style.transform = `translate(${x * 7}px, ${y * 5 - 2}px) scale(1.02)`;
    });
    btn.addEventListener('pointerleave', () => { btn.style.transform = ''; });
  });
}
});
